import moment from 'moment';

const dateTimeUtils = { 
  /**
   * Returns today's date as a string formatted MM-DD-YYYY (for export file names)
   * @returns {string}
   */
  getExportDateString() {
    const now = new Date();
    return now.toLocaleDateString('en-US').replace(/\//g, '-');
  },
 
  /**
   * 
   * @param {string} date - date of birth 
   * @param {number} requiredAge - minimum required age
   * @returns {boolean} this function returns true if the given birthday  makes the person older than the required age
   */
  isAgeAtLeast(date, requiredAge){
    const today = new Date()
    const birthdate = new Date(date)
    
    const difference = today.getTime() - birthdate.getTime(); 
    // new Date(0) returns a year of 1970
    const age = new Date(difference).getFullYear() - 1970;

    if (age >= requiredAge) {
      return true;
    }
    
    return false; 
  },
/**
 * 
 * @returns {object} - returns a new moment object
 */
  newDate() {
    return new Date();
  },

/**   
 * @param {object} date - a Date object ie new Date()
 * @param {number} years - number of years to subtract from the given moment object
 *  @returns {object} - returns a new moment object with the current date and time
 */ 
subtractYears(date, years) {
  const newDate = new Date();
  newDate.setFullYear(newDate.getFullYear() - years);
  return newDate;
},

/**
 * Returns today's local date as a 'YYYY-MM-DD' string, for use as a max date constraint.
 * Uses the local timezone offset so it doesn't shift a day off for users behind UTC.
 * @returns {string} ex: '2026-08-14'
 */
getLocalDateString() {
  return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
},

/**
 * We will likely want to phase out moment.js in the future due to its bundle size and the fact that it is no longer maintained.
 * until we upgrade to node 18 we will need to use moment for the date picker. 
 * This function will wrap that functionality so that we can eventualy phase moment out
 * @param {object} date - a Date object ie new Date()
 *  @returns {object} - returns a new moment object with the current date and time
 */
convertDateToMomentObject(date)  { 
  return  moment(date);  
},

/**
 * Compares two dates, wrapping moment.js so callers don't need to import it directly.
 * @param {Date|string} date - the date to check
 * @param {Date|string} dateToCompare - the date to compare against
 * @returns {boolean} true if date is after dateToCompare
 */
isAfter(date, dateToCompare) {
  return moment(date).isAfter(dateToCompare);
},

constants : {
  ONE_DAY_IN_MS: 1000 * 60 * 60 * 24,
  ONE_YEAR_IN_MS: 1000 * 60 * 60 * 24 * 365,
  ONE_MONTH_IN_MS: 1000 * 60 * 60 * 24 * 30,
  ONE_HOUR_IN_MS: 1000 * 60 * 60,
},

  /**
   * A utility to format dates. Currently uses moment.js as a dependency (https://momentjs.com/)
   */
  dateFormatter : {
    /**
     * Format a date 'M/D/YYYY' and convert to UTC
     * @param {Date} date 
     * @returns formatted date ex: '11/18/2023'
     */
    formatMDYYYY(date) {
        const formattedDate = moment(date).utc().format('M/D/YYYY');
        return formattedDate;
    },

    /**
     * Formats a date to the given format string, in local time (no UTC conversion).
     * Used for matching values against their displayed format (e.g. grid filtering).
     * @param {Date|string} date
     * @param {string} format - moment format string, defaults to 'M/D/YYYY'
     * @returns formatted date, or an empty string if date is falsy
     */
    formatLocal(date, format = 'M/D/YYYY') {
        return date ? moment(date).format(format) : '';
    }
  }
}




export default dateTimeUtils;